<template>
  <div id="ecasenkaDetail">
    <b-container>
      <b-row class="pt-3 pb-5">
        <b-col md="6" class="mb-3 d-flex align-items-center">
		  <InfoAboutDoctor />
        </b-col>
		<b-col md="6" class="mb-3">
		  <Info />
        </b-col>
		<b-col md="6" class="mb-3">
          <LeftContent />
        </b-col>
        <b-col md="6">
          <RightContent />
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="modal"
      ref="modal"
      hide-header
      ok-title="Súhlasím, pokračovať"
      cancel-title="zrušiť"
      @cancel="cancel"
      :static="true"
      scrollable
    >
      <!-- <p class="text-18 bold text-primary">{{ $t('modal_header') }}</p> -->
      <!-- <p class="text-14 semi-bold">{{ $t('modal_body') }}</p> -->

      <body>
        <div class="sect1">
          <h2 class="text-18 bold text-primary" id="_inform">
            INFORMÁCIE PRE DOTKNUTÚ OSOBU PRI UDELENÍ SÚHLASU SO SPRACOVANÍM
            OSOBNÝCH ÚDAJOV
          </h2>
          <div class="sectionbody">
            <div class="paragraph">
              <p class="text-14 semi-bold">
                Tieto informácie Vám poskytuje prevádzkovateľ, ktorým je
                obchodná spoločnosť <strong>eČasenka, s.r.o.</strong>, so
                sídlom: Svätoplukova 2, 984 01 Lučenec, IČO:
                48&nbsp;322&nbsp;989, spoločnosť zapísaná v&nbsp;Obchodnom
                registri Okresného súdu Banská Bystrica, oddiel: Sro, vložka
                číslo: 28697/S (ďalej v&nbsp;texte aj „<strong
                  >eČasenka, s.r.o.</strong
                >“ v&nbsp;príslušnom gramatickom tvare), ktorá zbiera Vaše
                osobné údaje na základe Vami
                <strong
                  >poskytnutého súhlasu so spracovaním osobných údajov, ktorý
                  ste spoločnosti eČasenka, s.r.o. poskytli využitím Vášho
                  občianskeho preukazu, ktorý ste priložili ku kiosku
                  spoločnosti eČasenka, s.r.o. u&nbsp;poskytovateľa zdravotnej
                  starostlivosti, ku ktorému idete na vyšetrenie, čím ste
                  prejavili vôľu udeliť spoločnosti eČasenka, s.r.o. súhlas so
                  spracovaním Vašich osobných údajov vykonaním tohto
                  potvrdzujúceho úkonu (priložením občianskeho preukazu ku
                  kiosku spoločnosti eČasenka, s.r.o.) alebo ktorý ste
                  spoločnosti eČasenka, s.r.o. poskytli kliknutím na tlačidlo
                  „súhlasím“ pri súhlase so spracovaním osobných údajov pri
                  objednaní niektorej zo služieb na internetových stránkach
                  spoločnosti eČasenka, s.r.o. alebo prostredníctvom mobilnej
                  aplikácie alebo ktorý ste spoločnosti eČasenka, s.r.o.
                  poskytli kliknutím na tlačidlo „súhlasím“ na Kiosku
                  spoločnosti eČasenka, s.r.o. v&nbsp;ambulancii Poskytovateľa
                  zdravotnej starostlivosti.</strong
                >
              </p>
            </div>
            <div style="page-break-after: always;"></div>
          </div>
        </div>
        <div class="sect1">
          <h2 class="text-18 bold" id="_">
            Účel a&nbsp;právny základ spracovania osobných údajov
          </h2>
          <div class="sectionbody">
            <div class="paragraph">
              <p class="text-14 semi-bold">
                Spoločnosť eČasenka, s.r.o. zhromažďuje a&nbsp;spracúva Vaše
                osobné údaje iba v&nbsp;nevyhnutnom rozsahu na splnenie účelu,
                pre ktorý sa Vaše osobné údaje zbierajú, na základe Vami
                poskytnutého súhlasu so spracovaním osobných údajov. Spoločnosť
                eČasenka, s.r.o. zbiera Vaše osobné údaje získané na základe
                Vášho súhlasu so spracovaním osobných údajov iba na nasledujúci
                účel:
              </p>
            </div>
            <div class="ulist">
              <ul>
                <li>
                  <p class="text-14 semi-bold">
                    informovať poskytovateľa zdravotnej starostlivosti, ku
                    ktorému idete na vyšetrenie o&nbsp;Vašej totožnosti, t.j.
                    poskytnúť mu informácie o&nbsp;Vašom mene, priezvisku
                    a&nbsp;rodnom čísle (aby si Váš poskytovateľ zdravotnej
                    starostlivosti vedel pripraviť pre Vaše vyšetrenie alebo
                    poskytnutie inej služby ako je napr. vystavenie receptu,
                    Vašu zdravotnú dokumentáciu), Vašej príslušnosti
                    k&nbsp;zdravotnej poisťovni a&nbsp;poskytnúť mu informáciu
                    o&nbsp;tom, či máte nárok na plnú, alebo nevyhnutnú
                    zdravotnú starostlivosť.
                  </p>
                </li>
              </ul>
            </div>
            <div class="paragraph">
              <p class="text-14 semi-bold">
                Právny základ, na základe ktorého spoločnosť eČasenka, s.r.o.
                spracúva Vaše osobné údaje na uvedený účel, je daný:
              </p>
            </div>
            <div class="ulist">
              <ul>
                <li>
                  <p class="text-14 semi-bold">
                    podľa Článku 6 bod 1 písm. a) Nariadenia Európskeho
                    parlamentu a&nbsp;Rady (EÚ) 2016/679 zo dňa 27.04.2016
                    o&nbsp;ochrane fyzických osôb pri spracúvaní osobných údajov
                    a&nbsp;o&nbsp;voľnom pohybe takýchto údajov (ďalej len
                    „GDPR“), t.j. že ste vyjadrili súhlas so spracovaním Vašich
                    osobných údajov.
                  </p>
                </li>
              </ul>
            </div>
            <div class="paragraph">
              <p class="text-14 semi-bold">
                Spoločnosť eČasenka, s.r.o. bude zároveň na základe Vášho
                súhlasu, ktorý bol poskytnutý na uvedený účel spracovať Vaše
                osobné údaje len prostredníctvom nasledujúcich spracovateľských
                operácii:
              </p>
            </div>
            <div class="ulist">
              <ul>
                <li>
                  <p class="text-14 semi-bold">
                    získanie Vašich osobných údajov;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    zaznamenanie Vašich osobných údajov;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    uchovávanie Vašich osobných údajov;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    prehliadanie Vašich osobných údajov;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    vymazanie a&nbsp;likvidácia Vašich osobných údajov.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="sect1">
          <h2 class="text-18 bold" id="_zdroje_akateg">
            Zdroje a&nbsp;kategórie spracovaných osobných údajov
          </h2>
          <div class="sectionbody">
            <div class="paragraph">
              <p class="text-14 semi-bold">
                Spoločnosť eČasenka, s.r.o. získava Vaše osobné údaje,
                s&nbsp;ktorých spracovaním ste vyjadrili súhlas len z
                nasledujúcich zdrojov:
              </p>
            </div>
            <div class="ulist">
              <ul>
                <li>
                  <p class="text-14 semi-bold">
                    od Vašej zdravotnej poisťovne, ktorá spoločnosti eČasenka,
                    s.r.o. poskytuje Vaše osobné údaje v&nbsp;zmysle tohto
                    súhlasu na základe osobitnej zmluvy uzatvorenej medzi
                    zdravotnou poisťovňou a&nbsp;spoločnosťou eČasenka, s.r.o.
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    osobných údajov, ktoré spoločnosť eČasenka, s.r.o. získala
                    od Vás prostredníctvom kiosku umiestneného v&nbsp;ambulancii
                    poskytovateľa zdravotnej starostlivosti, ktorý ste použili
                    na prečítanie Vašich identifikačných údajov z Vášho
                    občianskeho preukazu;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    osobných údajov získaných od Vás online prostredníctvom
                    www.ecasenka.sk alebo prostredníctvom aplikácií pre mobilné
                    zariadenia eČasenka
                  </p>
                </li>
              </ul>
            </div>
            <div class="paragraph">
              <p class="text-14 semi-bold">
                Spoločnosť eČasenka, s.r.o. zbiera na splnenie účelu, pre ktoré
                ste spoločnosti eČasenka, s.r.o. poskytli súhlas so spracovaním
                osobných údajov len nasledujúce kategórie osobných údajov:
              </p>
            </div>
            <div class="ulist">
              <ul>
                <li>
                  <p class="text-14 semi-bold">
                    identifikačné osobné údaje, ktorými sú meno, priezvisko
                    a&nbsp;rodné číslo;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    údaje o&nbsp;tom, v&nbsp;akej poisťovni máte uzatvorené Vaše
                    zdravotné poistenie;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    údaje o&nbsp;tom, či Vaša zdravotná poisťovňa pre Vás
                    uhrádza poskytovateľovi zdravotnej starostlivosti plnú,
                    alebo nevyhnutnú zdravotnú starostlivosť
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="sect1">
          <h2 class="text-18 bold" id="_inform">
            Informácia o&nbsp;tom, komu spoločnosť eČasenka, s.r.o. Vaše osobné
            údaje poskytuje
          </h2>
          <div class="sectionbody">
            <div class="paragraph">
              <p class="text-14 semi-bold">
                Spoločnosť eČasenka, s.r.o. poskytuje Vaše osobné údaje získané
                na základe Vami udeleného súhlasu len Poskytovateľovi zdravotnej
                starostlivosti, ku ktorému idete na vyšetrenie alebo
                u&nbsp;ktorého chcete využiť inú službu poskytujúcu spoločnosťou
                eČasenka, s.r.o.
              </p>
            </div>
          </div>
        </div>
        <div class="sect1">
          <h2 class="text-18 bold" id="_doba_uchov">
            Doba uchovávania osobných údajov získaných na základe súhlasu
          </h2>
          <div class="sectionbody">
            <div class="paragraph">
              <p class="text-14 semi-bold">
                Spoločnosť eČasenka, s.r.o. bude Vaše osobné údaje získané na
                dosiahnutie účelu, pre ktorý ste spoločnosti eČasenka, s.r.o.
                poskytli súhlas so spracovaním Vašich osobných údajov uchovávať
                len počas nevyhnutne nutnej doby a&nbsp;za podmienky dodržania
                všetkých právnych predpisov platných na území Slovenskej
                republiky. Spoločnosť eČasenka, s.r.o. tak na účel, pre ktorý
                boli osobné údaje získané na základe Vášho súhlasu uchováva Vaše
                osobné údaje iba po dobu 3 mesiacov od udelenia súhlasu.
                Následne spoločnosť eČasenka, s.r.o. Vaše osobné údaje
                poskytnuté na základe tohto súhlasu vymaže.
              </p>
            </div>
            <div class="paragraph">
              <p class="text-14 semi-bold">Práva dotknutej osoby</p>
            </div>
            <div class="paragraph">
              <p class="text-14 semi-bold">
                Ako dotknutá osoba podľa GDPR máte po overení Vašej totožnosti:
              </p>
            </div>
            <div class="ulist">
              <ul>
                <li>
                  <p class="text-14 semi-bold">
                    <strong
                      >právo odvolať súhlas so spracovaním osobných
                      údajov</strong
                    >&nbsp;- máte právo kedykoľvek po udelení súhlasu so
                    spracúvaním osobných údajov počas doby, na ktorú bol tento
                    súhlas udelený, tento súhlas kedykoľvek odvolať a&nbsp;to
                    rovnakým spôsobom akým bol tento súhlas poskytnutý;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    <strong
                      >požadovať od spoločnosti eČasenka, s.r.o. prístup k
                      svojím&nbsp;osobným údajom a&nbsp;právo získať od
                      spoločnosti eČasenka, s.r.o. potvrdenie o&nbsp;tom, či
                      táto spracúva Vaše osobné údaje</strong
                    >&nbsp;- na základe práva na prístup k&nbsp;osobným údajom
                    máte právo aby Vám spoločnosť eČasenka, s.r.o. bezodplatne
                    poskytla jednu kópiu osobných údajov, ktoré spoločnosť
                    eČasenka, s.r.o. spracúva. Za akékoľvek ďalšie kópie,
                    o&nbsp;ktoré požiadate, môže spoločnosť eČasenka, s.r.o.
                    účtovať primeraný poplatok zodpovedajúci administratívnym
                    nákladom. Ak podáte žiadosť elektronickými prostriedkami,
                    informácie Vám spoločnosť eČasenka, s.r.o. poskytne
                    v&nbsp;bežne používanej elektronickej podobe, pokiaľ
                    nepožiadate o&nbsp;iný spôsob poskytnutia;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    <strong>na opravu osobných údajov</strong>&nbsp;- máte právo
                    aby spoločnosť eČasenka, s.r.o. bez zbytočného odkladu
                    opravila Vaše nesprávne osobné údaje alebo aby prípadné
                    neúplné osobné údaje spoločnosť eČasenka doplnila;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    <strong>vymazanie osobných údajov</strong>&nbsp;- máte právo
                    požadovať aby spoločnosť eČasenka, s.r.o. bez zbytočného
                    odkladu vymazala Vaše osobné údaje, ak (A) osobné údaje už
                    nie sú potrebné na účel podľa súhlasu, na ktorý sa získali
                    alebo spracúvali; (B) odvoláte súhlas, na základe ktorého
                    spoločnosť eČasenka, s.r.o. osobné údaje spracúva; alebo ©
                    ak sa osobné údaje spracúvali nezákonne;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    <strong>obmedzenie spracúvania Osobných údajov</strong
                    >&nbsp;- ak (A) napadnete správnosť osobných údajov,
                    a&nbsp;to počas obdobia umožňujúceho spoločnosti eČasenka,
                    s.r.o. overiť správnosť Vašich osobných údajov; (B)
                    spracúvanie osobných údajov na základe súhlasu je
                    protizákonné a namietate proti vymazaniu osobných údajov
                    a&nbsp;žiadate namiesto toho obmedzenie ich použitia; ©
                    spoločnosť eČasenka, s.r.o. už nepotrebuje osobné údaje na
                    účel udelený súhlasom, ale potrebujete ich Vy ako dotknutá
                    osoba na preukázanie, uplatňovanie alebo obhajovanie Vašich
                    právnych nárokov. V&nbsp;prípade, ak dôjde k&nbsp;obmedzeniu
                    spracúvania osobných údajov s&nbsp;výnimkou spôsobu
                    spracovania uchovávaním osobných údajov, môže spoločnosť
                    eČasenka, s.r.o. akýmkoľvek iným spôsob spracúvať Vaše
                    osobné údaje len s&nbsp;Vaším súhlasom;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    <strong>na prenosnosť Osobných údajov</strong>&nbsp;- právo
                    získať osobné údaje, ktoré sa Vás týkajú a&nbsp;ktoré ste
                    poskytli spoločnosti eČasenka, s.r.o.,
                    v&nbsp;štruktúrovanom, bežne používanom a&nbsp;strojovo
                    čitateľnom formáte a&nbsp;máte právo preniesť tieto údaje
                    ďalšiemu prevádzkovateľovi bez toho, aby Vám spoločnosť
                    eČasenka, s.r.o. bránila. Máte právo na prenosnosť osobných
                    údajov priamo od spoločnosti eČasenka, s.r.o. inému
                    prevádzkovateľovi, pokiaľ je to technicky možné;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    <strong
                      >namietať z&nbsp;dôvodov týkajúcich sa konkrétnej situácie
                      proti spracúvaniu Osobných údajov</strong
                    >&nbsp;- ak je spracúvanie vykonávané na splnenie úlohy
                    realizovanej vo verejnom záujme alebo pri výkone verejnej
                    moci zverenej spoločnosti eČasenka, s.r.o. alebo je
                    spracúvanie nevyhnutné na účely oprávnených záujmov, ktoré
                    sleduje spoločnosť eČasenka, s.r.o. alebo tretia strana,
                    s&nbsp;výnimkou prípadov, keď nad takýmito záujmami
                    prevažujú Vaše záujmy alebo základné práva a&nbsp;slobody,
                    ktoré si vyžadujú ochranu osobných údajov;
                  </p>
                </li>
                <li>
                  <p class="text-14 semi-bold">
                    <strong>podať sťažnosť dozornému orgánu</strong>&nbsp;-
                    ktorým je v&nbsp;Slovenskej republike Úrad na ochranu
                    osobných údajov Slovenskej republiky so sídlom
                    v&nbsp;Bratislave, ak sa domnievate, že spracúvanie Vašich
                    osobných údajov je v&nbsp;rozpore s&nbsp;príslušných
                    právnymi predpismi Slovenskej republiky upravujúcimi ochranu
                    osobných údajov.
                  </p>
                </li>
              </ul>
            </div>
            <div class="paragraph">
              <p class="text-14 semi-bold">
                V&nbsp;prípade, ak chcete využiť niektoré z&nbsp;Vašich práv
                podľa predchádzajúceho odseku a&nbsp;žiadosť o&nbsp;využitie
                tohto práva doručíte spoločnosti eČasenka, s.r.o. elektronickými
                prostriedkami bez zaručeného elektronického podpisu alebo
                v&nbsp;listinnej podobe bez Vášho úradne osvedčeného podpisu
                alebo telefonicky, kedy spoločnosť eČasenka, s.r.o. môže mať
                dôvodné pochybnosti o&nbsp;totožnosti fyzickej osoby, ktorá túto
                žiadosť podáva, má spoločnosť eČasenka, s.r.o. v&nbsp;súlade
                s&nbsp;Článkom 12 bod 6 GDPR právo požadovať od Vás dodatočné
                informácie alebo vykonanie určitého úkonu smerujúceho k overeniu
                Vašej totožnosti (t.j. pre overenie či žiadosť podala osoba,
                ktorá aj skutočne využila služby spoločnosti eČasenka, s.r.o.
                a&nbsp;táto spracúva jej osobné údaje) a&nbsp;teda spoločnosť
                eČasenka, s.r.o. má právo od Vás požadovať aby ste žiadosť
                o&nbsp;využitie niektorého/ých práva podľa bodu 1. tohto Článku
                doručili spoločnosti eČasenka, s.r.o. elektronicky so zaručeným
                elektronickým podpisom alebo listinne s&nbsp;Vaším úradne
                overeným podpisom alebo aby ste sa osobne dostavili do sídla
                spoločnosti eČasenka, s.r.o. na overenie Vašej totožnosti.
              </p>
            </div>
          </div>
        </div>
      </body>
    </b-modal>
  </div>
</template>

<script>
import Info from "./components/Info.vue";
import InfoAboutDoctor from "./components/InfoAboutDoctor.vue";
import RightContent from "./components/RightContent.vue";
import LeftContent from "./components/LeftContent.vue";
import "./assets/custom.scss";
import config from "../config";

export default {
  name: "ecasenkaDetail",
  components: {
  	Info,
  	InfoAboutDoctor,
    RightContent,
    LeftContent
  },
  beforeCreate() {
    // this.$store.commit("setName", window.location.pathname.split("/").pop());
	  if (this.$route.params.slug) {
		  this.$store.commit("setName", this.$route.params.slug);
	  } else if (window.doctor) {
		  this.$store.commit("setName", window.doctor);
	  }
  },
  mounted() {
		if (this.$route.name !== 'shop_thank_you') {
			
			this.$refs["modal"].show();
		}

	  // console.warn('kiosk cordova test');
	  if (window.cordova) {
	  	// console.warn('there is cordova');
	  } else {
	  	// console.warn('no cordova');
	  }
  },
  methods: {
    cancel() {
      location.href = config.URLHOME;
    }
  }
};
</script>

<style lang="scss"></style>
